var Recommendations = {
  data: {
    selectors: {
      container: "#overlay-recommendations"
    },

    transitioning: false
  },

  onReady: function() {
    console.log('show');
    var cart = document.getElementById('cart-offcanvas');

    cart.addEventListener('shown.bs.offcanvas', function () {
      var event = new CustomEvent("minicart:show");
      document.dispatchEvent(event);
    })

    cart.addEventListener('hide.bs.offcanvas', function () {
      var event = new CustomEvent("minicart:hide");
      document.dispatchEvent(event);
    })

    document.addEventListener('minicart:show', this.handleMinicartShow.bind(this));
    document.addEventListener('minicart:hide', this.handleMinicartHide.bind(this));
  },

  handleMinicartShow: function(e) {
    //console.log("[R]", "Here");
    if(this.data.transitioning){
      return;
    }
    this.data.transitioning = true;
    let overlay = document.getElementById('overlay-recommendations');
    overlay.classList.add('active');
    this.data.transitioning = false;
  },

  handleMinicartHide: function(e) {
    //console.log("[R]", "Here2!");
    if(this.data.transitioning){
      return;
    }
    this.data.transitioning = true;
    let overlay = document.getElementById('overlay-recommendations');
    overlay.classList.remove('active');
    this.data.transitioning = false;
  }
};

module.exports = Recommendations;